
import understand from "@/components/understand.vue"

const understandCom = {
    install: function(Vue){
        Vue.component('understand',understand)
    }
}

export default understandCom